import { useContext } from 'react';
import { BrandContext } from '../../context/Brand';

export function useBrand() {
	const ctx = useContext(BrandContext);
	if (!ctx) throw new Error('Cannot use useBrand() outside Brand Provider');
	return ctx;
}
